export default __webpack_public_path__ + "static/media/0000..0000.f03c8e5d.png";